import PropTypes from 'prop-types';

import styles from './CameraStreamHeader.module.css';

const CameraStreamHeaderInfo = ({ title, gateName, direction }) => {
    if (!gateName) return null;

    return (
        <section className={styles['tc-cs-header--info']}>
            <p className={styles['header-text']}>
                {title} | {gateName} | {direction}
            </p>
        </section>
    );
};

CameraStreamHeaderInfo.propTypes = {
    gateName: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default CameraStreamHeaderInfo;
